import actions from './actions';

const {
  GET_SHIFT_LOAD,
  GET_SHIFT_SUCCESS,
  GET_SHIFT_ERROR,
  ADD_SHIFT_BEGIN,
  ADD_SHIFT_SUCCESS,
  ADD_SHIFT_ERROR,
  GET_SHIFT_SINGLE__LOAD,
  GET_SHIFT_SINGLE__SUCCESS,
  GET_SHIFT_SINGLE__ERROR,
  GET_SHIFT_CLEAR_OBJECT,
  UPDATE_SHIFT_BEGIN,
  UPDATE_SHIFT_ERROR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
  shift: null,
};

const shiftsReducer = (state = initialState, action) => {
  const { type, shifts, err } = action;

  switch (type) {
    case GET_SHIFT_LOAD:
      return { ...state, loading: true };

    case GET_SHIFT_SUCCESS:
      return { ...state, data: shifts, error: false, loading: false };

    case GET_SHIFT_ERROR:
      return { ...state, error: err, loading: false };

    case ADD_SHIFT_BEGIN:
      return { ...state, loading: true };

    case ADD_SHIFT_SUCCESS:
      return { ...state, data: shifts, loading: true, error: false };

    case ADD_SHIFT_ERROR:
      return { ...state, error: err, loading: false };

    case GET_SHIFT_SINGLE__LOAD:
      return { ...state, loading: true };

    case GET_SHIFT_SINGLE__SUCCESS:
      return { ...state, shift: shifts, error: false, loading: false };

    case GET_SHIFT_SINGLE__ERROR:
      return { ...state, shift: null, error: err, loading: false };

    case UPDATE_SHIFT_BEGIN:
      return { ...state, loading: true };

    case UPDATE_SHIFT_ERROR:
      return { ...state, shift: shifts, error: err, loading: false };

    case GET_SHIFT_CLEAR_OBJECT:
      return { ...state, shift: null, loading: false, error: false };

    default:
      return state;
  }
};

export { shiftsReducer };
